(async () => {
  if (!customElements.get('product-tab')) {
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        const drawerTriggers = document.querySelectorAll('[data-drawer-trigger]');
        this.tabsElement = this.querySelector('[data-tabs]');

        // Toggle product details tab visibility on desktop
        this.toggleVisibilityDetails();

        // Catch click on tab navigation
        this.tabsElement
          .querySelectorAll('[data-tabs-link]')
          .forEach((link) =>
            link.addEventListener('click', this.linkClick.bind(this, event, link))
          );

        // Catch click on drawer trigger

        drawerTriggers.forEach((link) =>
          link.addEventListener('click', this.triggerClick.bind(this, event, link))
        );
      }

      toggleVisibilityDetails() {
        const TabElelents = document.querySelectorAll('[data-tabs-link]');
        const TabElelentsContent = document.querySelectorAll('[data-tabs-content-pane]');

        //Toggle product details tab visibility
        if (TabElelents[0] && TabElelentsContent[0]) {
          TabElelents[0].classList.add('is-active');
          TabElelentsContent[0].classList.add('is-active');
        }
      }

      triggerClick(event, trigger) {
        const title = trigger.dataset.drawerTrigger;

        const TabElelents = this.tabsElement.querySelectorAll('[data-tabs-link]');
        // Only do something when the tab is not active
        TabElelents.forEach((link) => {
          if (!link.classList.contains('is-active')) {
            // Close the active tab and open the clicked tab after that
            this.closeActiveTab(title);

            // Open the clicked tag link
            this.openTabNavLink(title);
            this.scrollToTab(title);
            return;
          }
        });
      }

      linkClick(event, link) {
        const title = link.dataset.tabsLink;

        // Only do something when the tab is not active
        if (!link.classList.contains('is-active')) {
          // Close the active tab and open the clicked tab after that
          this.closeActiveTab(title);

          // Open the clicked tag link
          this.openTabNavLink(title);
        } else {
          // Close the active tab
          this.closeCurrentTab(title);
        }
      }

      closeActiveTab(title) {
        const activeTab = this.tabsElement.querySelector('.is-active');
        // If there is an active tab
        if (activeTab) {
          // Get title
          const activeTitle = activeTab.dataset.tabsLink;
          // Don't reopen self
          if (activeTitle === title) {
            return;
          }

          this.closeTab(activeTitle);
          this.closeTabNavLink(activeTitle);
        }

        this.openTab(title);
      }

      closeCurrentTab(title) {
        const activeTab = this.tabsElement.querySelector('.is-active');
        // If there is an active tab
        if (activeTab) {
          // Get title
          const activeTitle = activeTab.dataset.tabsLink;

          // Close current tab
          this.closeTab(activeTitle);
        }
      }

      closeTab(title) {
        // Close the tab and tab link content
        this.tab = this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');

        this.tabContent = this.tabsElement.querySelector(
          '[data-tabs-content-pane="' + title + '"]'
        );
        if (this.tab) {
          this.tab.classList.remove('is-active');
          this.tabContent.classList.remove('is-active');
        }
      }

      closeTabNavLink(title) {
        // Close the tab link in nav
        this.tab = this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
        if (this.tab) {
          this.tab.classList.remove('is-active');
        }
      }

      openTab(title) {
        // Open new tab and the tab content
        this.openClickedTab = this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
        if (this.openClickedTab) {
          this.openClickedTab.classList.add('is-active');
        }
        this.openClickedTabContent = this.tabsElement.querySelector(
          '[data-tabs-content-pane="' + title + '"]'
        );
        if (this.openClickedTabContent) {
          this.openClickedTabContent.classList.add('is-active');
        }
      }

      openTabNavLink(title) {
        // Open new tab
        this.openClickedTab = this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
        if (this.openClickedTab) {
          this.openClickedTab.classList.add('is-active');
        }
      }
      scrollToTab(title) {
        const TabElelents = this.tabsElement.querySelectorAll('[data-tabs-link]');
        TabElelents.forEach((link) => {
          link.classList.remove('swiper-slide-active');
        });
        this.openClickedTab = this.tabsElement.querySelector('[data-tabs-link="' + title + '"]');
        this.openClickedTab.classList.add('swiper-slide-active');
        this.openClickedTab.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center',
        });
      }
    }
    customElements.define('product-tabs', ProductTabs);
  }
})();
